// extracted by mini-css-extract-plugin
export default {"transactionRecords":"transactionRecords_transactionRecords__xIQJ6","title":"transactionRecords_title__t1C0T","venue":"transactionRecords_venue__JfG9a"};